import AppleIcon from "@mui/icons-material/Apple";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PlayStoreIcon from "assets/img/static/icon/playstoreIcon.png";
import { FC } from "react";
import { Link } from "react-router-dom";

interface AppCardProps {
  variant: "google" | "apple";
  Icon?: React.ReactNode;
  heading?: string | number;
  desc?: string;
  link?: string;
  light?: boolean;
  bgColor?: string;
}

const AppCard: FC<AppCardProps> = ({
  variant,
  Icon,
  heading,
  desc,
  link,
  light,
  bgColor,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      py={1}
      px={2}
      sx={{
        backgroundColor: bgColor || "",
        border: `1px solid ${bgColor || "rgba(0,0,0,0.1)"}`,
        borderRadius: "8px",
        cursor: "pointer",
        minWidth: 220,
        width: "fit-content",
        position: "relative",
      }}
    >
      <Box display="flex" justifyContent="center" alignItems="center">
        {variant === "google" ? (
          <>
            <Box
              component="img"
              src={PlayStoreIcon}
              alt="Play Store"
              sx={{
                width: "auto",
                height: "100%",
                minHeight: 48,
                objectFit: "contain",
              }}
            />
          </>
        ) : (
          <AppleIcon sx={{ fontSize: 48, color: "inherit" }} />
        )}
      </Box>
      <Box pl={1} className="fm-poppins">
        {variant === "google" ? (
          <>
            <Typography
              fontSize={14}
              fontWeight={400}
              textTransform="uppercase"
            >
              Get it on
            </Typography>
            <Typography fontSize={30} fontWeight={600} lineHeight={1.3}>
              Google Play
            </Typography>
          </>
        ) : (
          <>
            <Typography fontSize={14} fontWeight={400}>
              Download on the
            </Typography>
            <Typography fontSize={24} fontWeight={500} lineHeight={1}>
              App Store
            </Typography>
          </>
        )}
      </Box>
      {link && <Link to={link} target="_blank" className="stretched-link" />}
    </Box>
  );
};

export default AppCard;
